import { render, staticRenderFns } from "./AboutInfo.vue?vue&type=template&id=473e14e2&scoped=true&"
import script from "./AboutInfo.vue?vue&type=script&lang=js&"
export * from "./AboutInfo.vue?vue&type=script&lang=js&"
import style0 from "./AboutInfo.vue?vue&type=style&index=0&id=473e14e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473e14e2",
  null
  
)

export default component.exports